module.exports = __webpack_public_path__ + "img/laminate_four.8e122958.png";